import { useState } from 'react';
import axios from 'axios';
import { Plus } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function CampaignSelector({ campaigns, selectedCampaign, onSelect, onCreateNew }) {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newCampaign, setNewCampaign] = useState({
    name: '',
    description: '',
    dialing_mode: 'preview'
  });

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(
        `${API_BASE}/dialer/campaigns`,
        newCampaign,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSelect(response.data);
      setShowCreateModal(false);
      setNewCampaign({ name: '', description: '', dialing_mode: 'preview' });
      onCreateNew();
    } catch (error) {
      console.error('Error creating campaign:', error);
      alert('Failed to create campaign');
    }
  };

  return (
    <div className="flex items-center gap-4">
      <select
        value={selectedCampaign?.id || ''}
        onChange={(e) => {
          const campaign = campaigns.find(c => c.id === parseInt(e.target.value));
          onSelect(campaign);
        }}
        className="border rounded px-4 py-2"
      >
        <option value="">Select Campaign</option>
        {campaigns.map((campaign) => (
          <option key={campaign.id} value={campaign.id}>
            {campaign.name}
          </option>
        ))}
      </select>
      <button
        onClick={() => setShowCreateModal(true)}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
      >
        <Plus className="w-4 h-4" />
        New Campaign
      </button>

      {showCreateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-xl font-semibold mb-4">Create New Campaign</h3>
            <form onSubmit={handleCreate} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                  type="text"
                  value={newCampaign.name}
                  onChange={(e) => setNewCampaign({ ...newCampaign, name: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Description</label>
                <textarea
                  value={newCampaign.description}
                  onChange={(e) => setNewCampaign({ ...newCampaign, description: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Dialing Mode</label>
                <select
                  value={newCampaign.dialing_mode}
                  onChange={(e) => setNewCampaign({ ...newCampaign, dialing_mode: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="manual">Manual</option>
                  <option value="preview">Preview</option>
                </select>
              </div>
              <div className="flex gap-2 justify-end">
                <button
                  type="button"
                  onClick={() => setShowCreateModal(false)}
                  className="px-4 py-2 border rounded hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}


